module.exports = __webpack_public_path__ + "img/home_banner_1.1f53275b.png";